import React from "react";
import { Clock } from "lucide-react";

/**
 * Time picker built on top of the native HTML5 `<input type="time">`. With
 * `step={900}` (900 sec = 15 min) iOS/Android show their native wheel picker
 * with quarter-hour increments, which is the most ergonomic option on mobile
 * (no tiny dropdown to scroll). On desktop the browser renders a text field
 * with up/down arrows.
 *
 * Value/onChange are plain "HH:mm" strings to match the rest of the codebase.
 *
 * Props:
 *   value, onChange, placeholder, className, "data-testid", disabled
 */
export default function TimePicker({
    value,
    onChange,
    className = "",
    "data-testid": testId = "time-picker",
    disabled = false,
    minTime = "07:00",
    maxTime = "19:00",
}) {
    return (
        <div className={`relative ${className.includes("h-") ? "" : "h-11"}`}>
            <Clock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500 pointer-events-none" />
            <input
                type="time"
                step="900"
                min={minTime}
                max={maxTime}
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
                data-testid={testId}
                className={`w-full h-full pl-9 pr-3 bg-[#F4F4F5] border border-zinc-200 rounded-sm text-zinc-950 text-sm focus:outline-none focus:border-[#E5A93D] disabled:opacity-50 disabled:cursor-not-allowed [color-scheme:dark] ${className}`}
            />
        </div>
    );
}
